/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["CHECK_EMAIL", "CREATE_TOKEN"];

class StartMigration extends Component {
  state = {
    email: "",
    emailError: "",
    mustValidateData: false,
  };

  componentDidMount() {
    document.title = "Вход - A1 Xplore TV GO";

    try {
      sessionStorage.clear();
    } catch (err) {
      /* */
    }

    const { process, clearErrors } = this.props;

    clearErrors(actionsNames);

    if (process.email && process.email.length) {
      this.setState({ email: process.email });
    }

    this.handleAutofocus();
  }

  componentDidUpdate(prevProps) {
    const { email } = this.state;
    const { loading, history, process, error, createToken } = this.props;

    if (!loading && !(error && error.length) && !(process.token && process.token.error) && !process.checkEmailError) {
      // Typical usage (don't forget to compare props):
      if (
        process.isMigrated !== prevProps.process.isMigrated ||
        process.isEligible !== prevProps.process.isEligible ||
        process.isSuspended !== prevProps.process.isSuspended ||
        process.isAddon !== prevProps.process.isAddon ||
        process.token !== prevProps.process.token
      ) {
        if (process.isMigrated === true) {
          if (process.isEligible === true) {
            if (process.isSuspended === true) {
              history.push("/suspended");
            } else {
              window.location.href = "https://new.a1xploretv.bg";
              return false;
            }
          } else if (process.isSuspended === true) {
            history.push("/suspended");
          } else if (process.isAddon === true) {
            history.push("/addon");
          } else {
            history.push("/preview");
          }
        } else if (process.token && process.token.isOk === true) {
          history.push("/email");
        } else if (process.token === null) {
          createToken(email);
        }
      }
      return false;
    }
    this.handleAutofocus();
    return false;
  }

  handleInputChange = event => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const { mustValidateData } = this.state;
    const { error, process, clearErrors, resetEmailError } = this.props;
    if (process.checkEmailError) {
      resetEmailError();
    }

    if (error && error.length) {
      clearErrors(actionsNames);
    }

    this.setState({
      [name]: value,
    });

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleInputOnKeyUp = event => {
    const { mustValidateData } = this.state;

    if (event.keyCode === 13) {
      this.handleNextClick();
    }

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleAutofocus = () => {
    const autofocusElements = document.getElementsByClassName("autofocus");
    if (autofocusElements && autofocusElements.length > 0) {
      autofocusElements[0].focus();
    }
  };

  validateData = () => {
    const { email } = this.state;
    let isValid = false;

    if (email.length > 0) {
      const re = /^\S+@\S+\.\S+$/;
      if (re.test(email)) {
        isValid = true;
        this.setState({ emailError: "" });
      } else {
        this.setState({
          emailError:
            "Въведеният e-mail е грешен. Моля, въведи отново, като използваш само малки букви на латиница, без интервали.",
        });
      }
    } else {
      this.setState({
        emailError: "Въведи e-mail адрес, като използваш само малки букви на латиница, без интервали.",
      });
    }

    return isValid;
  };

  // TODO: validate on input update after first NextClick
  handleNextClick = () => {
    const { email, mustValidateData } = this.state;
    const { setEmail, checkEmail, clearErrors, resetEmailError } = this.props;

    clearErrors(actionsNames);
    resetEmailError();

    if (!mustValidateData) {
      this.setState({ mustValidateData: true });
    }

    if (this.validateData()) {
      setEmail(email);
      checkEmail(email);
    }
  };

  render() {
    const { email, emailError } = this.state;
    const { loading, error, process } = this.props;
    const requestError = error && error.length ? error.map(err => <p>{err}</p>) : null;

    let divError = null;

    if (requestError) divError = requestError;
    else if (emailError) divError = emailError;
    else if (process.checkEmailError) divError = process.checkEmailError;
    else if (process.token && process.token.error) divError = process.token.error;

    divError = divError ? <div className="error">{divError}</div> : null;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    return (
      <div className="page page-login">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}

          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>
          <div className="container-body">
            <h1 className="tag-title">Въведи e-mail адрес</h1>

            <div className="tag-content" style={{ margin: "-36px 0 50px 0", lineHeight: 1.2 }}>
              <small>
                Моля въведи e-mail адрес за вход в приложението A1 Xplore TV.
                <br />
                Използвай само малки букви на латиница, без интервали.
              </small>
            </div>

            <div className="tag-textfield">
              <input
                type="text"
                name="email"
                id="email"
                className="autofocus tag-input"
                value={email}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />
              <label htmlFor="email">E-mail адрес</label>
            </div>

            {divError}

            <div className="tag-content" style={{ marginTop: "80px" }}>
              <button
                type="button"
                className="tag-btn tag-btn--active"
                onClick={this.handleNextClick}
                disabled={!!loading}
              >
                Продължи
              </button>
            </div>

            <div className="tag-content tag-content__help">
              <NavLink
                to="/passrecovery"
                className="tag-color-red"
                style={{ color: "#939393", textDecoration: "underline" }}
              >
                Забравена парола?
              </NavLink>
              <br />
              Имаш въпроси?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    setEmail: email => dispatch(processActions.setEmail(email)),
    checkEmail: email => dispatch(processActions.checkEmail(email)),
    createToken: email => dispatch(processActions.createToken(email)),
    resetEmailError: () => dispatch(processActions.resetEmailError()),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(StartMigration);
